import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select';
import {
  ENTITY_STATUS_OPTIONS,
  getEntityStatusInfo,
} from '@/utils/entityStatuses';

interface StatusFilterSelectProps {
  value: string;
  onChange: (value: string) => void;
  /** Translated "All statuses" label — kept as a prop rather than a shared
   * i18n key so each table owns its own translation namespace. */
  allStatusesLabel: string;
  /** Accessible name for the trigger. Without one the only name a screen
   * reader gets is the current value, which says nothing about what the
   * control filters. Defaults to the "all statuses" label. */
  ariaLabel?: string;
}

export const StatusFilterSelect: React.FC<StatusFilterSelectProps> = ({
  value,
  onChange,
  allStatusesLabel,
  ariaLabel,
}) => (
  <Select
    value={value || 'all'}
    onValueChange={v => onChange(v === 'all' ? '' : v)}
  >
    <SelectTrigger
      aria-label={ariaLabel ?? allStatusesLabel}
      className="px-4 py-2 border border-[#e9eaeb] rounded-md text-sm text-gray-600 font-medium hover:bg-gray-50 bg-white h-auto w-auto gap-2 [&>svg]:opacity-100"
    >
      <span>{value ? getEntityStatusInfo(value).label : allStatusesLabel}</span>
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{allStatusesLabel}</SelectItem>
      {ENTITY_STATUS_OPTIONS.map(opt => (
        <SelectItem key={opt.value} value={opt.value}>
          {opt.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
